import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingPagesRoutingModule } from './landing-pages-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as fromStore from './store';
import { CoreModule } from '../core/core.module';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { ContentBlocksModule } from '../content-blocks/content-blocks.module';
import { HeaderComponent } from '../standalone/header/header.component';
import { HeaderWithImageComponent } from '../standalone/header-with-image/header-with-image.component';
import { LandingPageComponent } from './containers/landing-page/landing-page.component';
import { HeaderPlayComponent } from '../standalone/header-play/header-play.component';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [
    CommonModule,
    CoreModule,
    LandingPagesRoutingModule,
    ContentBlocksModule,
    DictionaryNgrxModule,
    TextUtilityModule,
    HeaderComponent,
    CookieNgrxModule,
    HeaderWithImageComponent,
    HeaderPlayComponent,
    StoreModule.forFeature(fromStore.featureKey, fromStore.reducers, {
      metaReducers: fromStore.metaReducers,
    }),
    EffectsModule.forFeature(fromStore.effects),
  ],
})
export class LandingPagesModule {}
